import React, { FC } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { copyOfExploreResultsPageGenericClick } from '@wix/bi-logger-marketplace/v2';
import { Box, EmptyState, TextButton } from '@wix/design-system';
import { useBi } from '@components/Hooks/useBi';
import useMobileMediaQuery from '@components/Hooks/useMobileMediaQuery';
import { useProfileContext } from '@components/Contexts/ProfileContext';
import { useBiSessionContext } from '@components/Contexts/BiSessionContext';
import Header from '@components/Header';
import { PAGE_NAMES } from '@utils/partnerProfileUtils';
import s from './NotFound.module.scss';

interface Props {
  directoryHref?: string | null;
}

const NotFound: FC<Props> = ({ directoryHref }) => {
  const { t } = useTranslation();
  const logger = useBi();
  const { sessionId } = useBiSessionContext();
  const { entry, origin, isMobileUserAgent } = useProfileContext();
  const isMobileView = useMobileMediaQuery(isMobileUserAgent);

  function headerOnClick() {
    logger.report(
      copyOfExploreResultsPageGenericClick({
        clickType: 'marketplace top button',
        sessionId,
        origin,
        entry,
        exploreVersion: 'V2',
        data: '',
      }),
    );
  }

  return (
    <Box display="block" className={s.root}>
      <div className={s.stickyHeader}>
        <Header
          onClick={headerOnClick}
          sessionId={sessionId}
          pageName={PAGE_NAMES.NOT_FOUND_PAGE}
        />
      </div>
      <Box
        align="center"
        marginTop="256px"
        height={`calc(100vh - 256px - ${isMobileView ? '54px' : '72px'})`}
      >
        <EmptyState
          skin="page-no-border"
          title={t('profile-page-not-found-title')}
          subtitle={t('profile-page-not-found-subtitle')}
          dataHook="profile-page-not-found"
        >
          {directoryHref && (
            <Box marginTop="3px">
              <TextButton
                skin="standard"
                size="medium"
                weight="thin"
                as="a"
                href={directoryHref}
                dataHook="partners-not-found-cta"
              >
                {t('partners.page-not-found.cta')}
              </TextButton>
            </Box>
          )}
        </EmptyState>
      </Box>
    </Box>
  );
};

export default NotFound;
